import { fetchCollection } from './index'
import { servicingLabelSchema } from '../schemas/index'

export const LOCATION_SERVICING_LABELS_REQUEST = 'LOCATION_SERVICING_LABELS_REQUEST'
export const LOCATION_SERVICING_LABELS_SUCCESS = 'LOCATION_SERVICING_LABELS_SUCCESS'
export const LOCATION_SERVICING_LABELS_FAILURE = 'LOCATION_SERVICING_LABELS_FAILURE'

export function fetchLabelsForLocation (locationId) {
  return fetchCollection({
    url: `/locations/${locationId}/servicing_labels`,
    key: 'servicingLabels',
    schema: servicingLabelSchema,
    actions: [ LOCATION_SERVICING_LABELS_REQUEST, LOCATION_SERVICING_LABELS_SUCCESS, LOCATION_SERVICING_LABELS_FAILURE ],
    responseInterceptor: response => ({ ...response, locationId })
  })
}



// WEBPACK FOOTER //
// ./src/actions/servicing-labels.js